import {Component, Input, OnInit} from '@angular/core';
import {IonicModule} from "@ionic/angular";
import {TimelineEntry} from "@interfaces/timeline-entry";
import {NgIf} from "@angular/common";
import {DateAgoPipe} from "@app/pipes/date-ago.pipe";
import {RouterLink} from "@angular/router";
import {generateRandomInteger} from "@app/utils/helpers";
import {PinchZoomComponent} from "@meddv/ngx-pinch-zoom";
import {
  TimelineEntryActionButtonsComponent
} from "@app/components/timeline-entry-action-buttons/timeline-entry-action-buttons.component";

@Component({
  selector: 'app-news-card',
  templateUrl: './news-card.component.html',
  styleUrls: ['./news-card.component.scss'],
  imports: [
    IonicModule,
    NgIf,
    DateAgoPipe,
    RouterLink,
    PinchZoomComponent,
    TimelineEntryActionButtonsComponent,
  ]
})
export class NewsCardComponent implements OnInit {

  @Input() public entry: TimelineEntry;
  @Input() public small: boolean = false;
  @Input() public showActionButtons: boolean = true;
  @Input() public showOwner: boolean = true;

  defaultImage = 'default-' + generateRandomInteger(1, 2) + '.png'

  constructor() {
  }

  ngOnInit() {
    console.log('NewsCardComponent', this.entry.is_liked_by_user, this.entry.likes);
  }
}
